import { PLATFORM_RULES } from '@thinknet-gmbh/platform-common';
import { usePermissionContext } from 'src/contexts';

import { usePermissionCheck } from 'src/hooks/permission-check.hook';

export const useUserCanManageDocument = ({
  createdBy,
  platformPermission,
}: {
  createdBy?: string;
  platformPermission: string;
}) => {
  let canEdit = false;
  let canDelete = false;

  const { accountId, permissions } = usePermissionContext();
  const { isAdmin, isSuperAdmin } = usePermissionCheck(platformPermission);

  if (isAdmin || isSuperAdmin) {
    canEdit = true;
    canDelete = true;
  }

  const permission = permissions.find(perm => perm.permission === platformPermission);

  if (permission?.rule === PLATFORM_RULES.manageAll) {
    canEdit = true;
    canDelete = true;
  }

  if (permission?.rule === PLATFORM_RULES.manageOwn) {
    canEdit = createdBy === accountId;
    canDelete = createdBy === accountId;
  }

  return { canEdit, canDelete, isSuperAdmin, isAdmin };
};
